import { IntegrationUtils } from '@/core/utils/integration-utils';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'integrationNameKey',
    standalone: true,
    pure: true,
})
export class IntegrationNameKeyPipe implements PipeTransform {
    transform(serviceIdentifier: string): string {
        return IntegrationUtils.getIntName(serviceIdentifier);
    }
}
